var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activity-po-wo-wrapper',{attrs:{"rfqID":_vm.data.rfqID,"handleAutoSave":_vm.handleAutoSave},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var autoSaveMiddleware = ref.autoSaveMiddleware;
return [_c('activity-review-form',{attrs:{"data":_vm.data,"model":_vm.model},on:{"onAutoSave":autoSaveMiddleware,"onDetails":_vm.handleDetails}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }